module.exports = __webpack_public_path__ + "img/bloqhouse.f5106e07.png";